import { module as BaseModule } from 'modujs'
import { gsap } from 'gsap'

export default class extends BaseModule {
  init () {
    this.state = false
    this.hamburger = document.querySelector('[data-navigation-hamburger]')
    this.hamburger.addEventListener('click', this.toggleMenu.bind(this))

    this.timeline = gsap
      .timeline({ paused: true })
      .set('[data-navigation-nav]', { display: 'block' }, 0)
      .set('[data-navigation-nav] li', { opacity: 0 }, 0)
      .to('[data-navigation-nav] li', { opacity: 1, stagger: 0.1 })
  }

  toggleMenu () {
    if (this.state) {
      this.closeMenu()
    } else {
      this.openMenu()
    }
  }

  async openMenu () {
    this.state = true
    document.body.classList.add('has-menu')
    this.el.setAttribute('aria-expanded', true)
    this.timeline.timeScale(1)
    this.timeline.play()
  }

  async closeMenu () {
    this.state = false
    document.body.classList.remove('has-menu')
    this.el.setAttribute('aria-expanded', false)
    this.timeline.timeScale(1.5)
    this.timeline.reverse()
  }
}
